export const BYLINE_LAYOUT_WINDOW_MS = 10_000;
